import styled from 'styled-components';
import { COLORS, FONTS } from '@app/src/ui';

export const FrameWrapper = styled.div`
  font-size: 18px;
  font-family: ${FONTS.ROBOTO_REGULAR};
  text-align: center;
  a {
    text-decoration: underline;
    color: ${COLORS.AQUA_BLUE};
  }
`;

export const FrameContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 258px;
  margin-top: 27px;
  font-family: ${FONTS.ROBOTO_REGULAR};
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 20px;

  @media(min-width: 480px) {
    width: 360px;
  }
`;
